/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonCloudflareTurnstileSiteVerifyInfo } from '../models/BabylonCloudflareTurnstileSiteVerifyInfo';
import type { BabylonCloudflareTurnstileSiteVerifyRequest } from '../models/BabylonCloudflareTurnstileSiteVerifyRequest';
import type { SomniaCloudflareTurnstileSiteVerifyInfo } from '../models/SomniaCloudflareTurnstileSiteVerifyInfo';
import type { SomniaCloudflareTurnstileSiteVerifyRequest } from '../models/SomniaCloudflareTurnstileSiteVerifyRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CloudflareControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public verifyTurnstileToken({
        requestBody,
    }: {
        requestBody: (BabylonCloudflareTurnstileSiteVerifyRequest | SomniaCloudflareTurnstileSiteVerifyRequest),
    }): CancelablePromise<(BabylonCloudflareTurnstileSiteVerifyInfo | SomniaCloudflareTurnstileSiteVerifyInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/cloudflare/turnstile/site/verify',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
